module.exports = __webpack_public_path__ + "img/BG121856059.d6d1393e.svg";